module.exports = __webpack_public_path__ + "img/icon-implantation-01.4883dd09.svg";